import { call, put, takeEvery } from "redux-saga/effects";

import {
  DELETE_APP,
  GET_APPS
} from "./actionTypes";

import {
  deleteAppError,
  deleteAppSuccess,
  getAppsError,
  getAppsSuccess
} from "./actions";

import {
  deleteApp,
  getCall,
} from "../../../../helpers/fakebackend_helper";

import * as constClass from "../../../../common/constant/constantURL";

function* getApps1(pageDetails) {
  try {
    let data = pageDetails.payload
    let url = constClass.REST_API_THIRDPARTYAPP+`?page=${data.pageNumber}&pageSize=${data.pageSize}`

     
    let response = yield call(getCall, url);
    yield put(getAppsSuccess(response));
  } catch (error) {
    yield put(getAppsError(error));
  }
}

function* deleteAppHandler({payload: {id}}) {
  try {
    const response = yield call(deleteApp, constClass.REST_API_THIRDPARTYAPP+"/"+id);
    yield put(deleteAppSuccess("done"));
  } catch (error) {
    yield put(deleteAppError(error));
  }
}

function* thirdPartAppSaga() {
  yield takeEvery(GET_APPS, getApps1);
  yield takeEvery(DELETE_APP, deleteAppHandler);
}

export default thirdPartAppSaga;
